<template>
  <div
    ref="pageScroller"
    class="shop-supply-page"
    @scroll.passive="handlePageScroll"
  >
    <header class="page-header">
      <button
        class="back-btn"
        type="button"
        :aria-label="$t('utils.cancel')"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shopCenter.supply') }}</h1>
    </header>

    <nav
      v-if="tabs.length"
      class="class-tabs"
    >
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="class-tab"
        :class="{ active: activeClass === tab.id }"
        type="button"
        @click="changeTab(tab.id)"
      >
        <span>{{ tab.title }}</span>
      </button>
    </nav>

    <main class="supply-content">
      <van-list
        ref="supplyList"
        v-model="listLoading"
        :finished="finished"
        :offset="120"
        :loading-text="$t('hotelList.loading')"
        @load="loadSupply"
      >
        <div
          v-if="rooms.length"
          class="room-grid"
        >
          <article
            v-for="item in rooms"
            :key="item.id"
            class="room-card"
            :class="{ selected: isSelected(item) }"
            role="button"
            tabindex="0"
            @click="toggleRoom(item)"
            @keyup.enter="toggleRoom(item)"
          >
            <div class="room-image">
              <img
                :src="roomImage(item)"
                alt=""
                @error="onRoomImageError"
              >
              <span
                v-if="isSelected(item)"
                class="selected-badge"
              >
                <van-icon name="success" />
              </span>
            </div>
            <h2>{{ item.title || '' }}</h2>
            <div class="room-meta">
              <span class="room-price">${{ formatPrice(item.price) }}</span>
              <span class="room-sold">{{ $t('hotelList.sold') }} {{ formatSold(item.sold) }}</span>
            </div>
          </article>
        </div>
        <div
          v-else-if="!requesting"
          class="empty-state"
        >
          {{ $t('hotelList.empty') }}
        </div>
      </van-list>
    </main>

    <div class="save-bar">
      <button
        type="button"
        class="save-btn"
        :disabled="saving"
        @click="saveSupply"
      >
        {{ $t('shopCenter.logoSave') }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon, List, Toast } from 'vant';

Vue.use(Icon).use(List).use(Toast);

const MIN_SUPPLY_PRODUCTS = 10;

export default {
  name: 'Shopsupply',
  data() {
    return {
      lang: this.$i18n.locale || localStorage.getItem('lang') || 'en_us',
      app: {},
      tabs: [],
      activeClass: 0,
      rooms: [],
      selectedMap: {},
      selectedReady: false,
      page: 1,
      limit: 20,
      listLoading: false,
      requesting: false,
      finished: false,
      saving: false,
      roomFallback: require('../images/shop2/pro.png'),
    };
  },
  computed: {
    selectedIds() {
      return Object.keys(this.selectedMap)
        .map((id) => Number(id))
        .filter((id) => id > 0);
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('walfare', false);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      this.loadSupply();
    },
    loadSupply() {
      if (this.requesting || this.finished) {
        this.listLoading = false;
        return;
      }
      this.requesting = true;
      this.listLoading = true;
      Fetch('/user/shop_supply', {
        class: this.activeClass,
        page: this.page,
        limit: this.limit,
        language: this.lang,
      }).then((r) => {
        var data = r.data || {};
        var list = Array.isArray(data.list) ? data.list : [];
        this.tabs = Array.isArray(data.cates) ? data.cates : [];
        this.activeClass = Number(data.active_class || 0);
        if (!this.selectedReady) {
          this.setSelectedMap(data.selected_ids);
        }
        this.rooms = this.page === 1 ? list : this.rooms.concat(list);
        this.finished = !data.has_more || list.length < this.limit;
        this.page += 1;
      }).catch(() => {
        if (this.page === 1) {
          this.rooms = [];
        }
        this.finished = true;
      }).finally(() => {
        this.requesting = false;
        this.listLoading = false;
        this.checkList();
      });
    },
    changeTab(id) {
      var nextId = Number(id || 0);
      if (this.activeClass === nextId) {
        return;
      }
      this.activeClass = nextId;
      this.resetList();
      this.loadSupply();
    },
    resetList() {
      this.page = 1;
      this.rooms = [];
      this.finished = false;
      this.listLoading = false;
      this.requesting = false;
    },
    setSelectedMap(ids) {
      var selected = {};
      if (Array.isArray(ids)) {
        ids.forEach((id) => {
          id = Number(id);
          if (id > 0) {
            selected[String(id)] = true;
          }
        });
      }
      this.selectedMap = selected;
      this.selectedReady = true;
    },
    isSelected(item) {
      return !!(item && this.selectedMap[String(item.id)]);
    },
    toggleRoom(item) {
      if (!item || !item.id) {
        return;
      }
      var id = String(item.id);
      if (this.selectedMap[id]) {
        this.$delete(this.selectedMap, id);
      } else {
        this.$set(this.selectedMap, id, true);
      }
    },
    syncSavedSelection(ids) {
      var selected = {};
      ids.forEach((id) => {
        id = Number(id);
        if (id > 0) {
          selected[String(id)] = true;
        }
      });
      this.selectedMap = selected;
    },
    saveSupply() {
      if (this.saving) {
        return;
      }
      var ids = this.selectedIds;
      if (ids.length < MIN_SUPPLY_PRODUCTS) {
        Toast(this.$t('shopCenter.supplyMinimum'));
        return;
      }
      this.saving = true;
      Fetch('/user/shop_supply_save', {
        ids: ids.join(','),
        language: this.lang,
      }, null, true).then((r) => {
        var data = r.data || {};
        this.syncSavedSelection(Array.isArray(data.selected_ids) ? data.selected_ids : ids);
        Toast(this.getResponseMessage(r.info, this.$t('shopCenter.logoSaveSuccess')));
      }).catch(() => {
        Toast(this.$t('shopCenter.logoSaveFail'));
      }).finally(() => {
        this.saving = false;
      });
    },
    handlePageScroll(event) {
      var target = event && event.target ? event.target : this.$refs.pageScroller;
      if (!target || this.requesting || this.finished) {
        return;
      }
      var distance = target.scrollHeight - target.scrollTop - target.clientHeight;
      if (distance <= 120) {
        this.loadSupply();
      }
    },
    checkList() {
      this.$nextTick(() => {
        if (this.$refs.supplyList && typeof this.$refs.supplyList.check === 'function') {
          this.$refs.supplyList.check();
        }
        this.handlePageScroll({
          target: this.$refs.pageScroller,
        });
      });
    },
    getResponseMessage(info, fallback) {
      var lang = localStorage.getItem('lang') || this.lang || 'en_us';
      if (info && typeof info === 'object') {
        return info[lang] || info.en_us || info.zh_cn || fallback;
      }
      return info || fallback;
    },
    buildImageUrl(path, fallback) {
      if (!path) {
        return fallback;
      }
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    roomImage(item) {
      return this.buildImageUrl(item && item.img, this.roomFallback);
    },
    onRoomImageError(event) {
      if (event && event.target && event.target.src !== this.roomFallback) {
        event.target.src = this.roomFallback;
      }
    },
    formatPrice(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        number = 0;
      }
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatSold(value) {
      var number = Number(value);
      if (!isFinite(number) || number < 0) {
        number = 0;
      }
      if (number >= 1000) {
        var shortNumber = number / 1000;
        var fixed = shortNumber >= 10 ? shortNumber.toFixed(0) : shortNumber.toFixed(1);
        return fixed.replace(/\.0$/, '') + 'k+';
      }
      return String(Math.floor(number));
    },
  },
};
</script>

<style lang="less" scoped>
.shop-supply-page {
  height: 100vh;
  min-height: 100vh;
  padding-bottom: 96px;
  overflow-y: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  background: #f4f5fb;
  color: #061429;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 12;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.page-header h1 {
  margin: 0;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
}

.back-btn {
  position: absolute;
  left: 18px;
  top: 15px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #071426;
  font-size: 22px;
}

.class-tabs {
  position: sticky;
  top: 58px;
  z-index: 11;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  height: 58px;
  background: #fff;
  box-shadow: 0 1px 0 rgba(230, 234, 242, .9);
}

.class-tab {
  position: relative;
  min-width: 0;
  padding: 0 8px;
  border: 0;
  background: transparent;
  color: #495268;
  font-size: 14px;
  line-height: 58px;
  text-align: center;
}

.class-tab span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class-tab.active {
  color: #061429;
  font-weight: 700;
}

.class-tab.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 54px;
  height: 3px;
  border-radius: 3px;
  transform: translateX(-50%);
  background: #2389ff;
}

.supply-content {
  padding: 16px 16px 4px;
}

.room-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 18px;
}

.room-card {
  min-width: 0;
  cursor: pointer;
  outline: none;
}

.room-image {
  position: relative;
  width: 100%;
  height: 102px;
  overflow: hidden;
  border-radius: 6px;
  background: #e5e7ef;
}

.room-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.selected-badge {
  position: absolute;
  right: -1px;
  top: -1px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #248dff;
  color: #fff;
  font-size: 16px;
  box-shadow: 0 4px 10px rgba(36, 141, 255, .22);
}

.room-card h2 {
  height: 34px;
  margin: 7px 0 0;
  overflow: hidden;
  color: #061429;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  word-break: break-word;
}

.room-meta {
  display: flex;
  align-items: baseline;
  min-width: 0;
  margin-top: 3px;
  line-height: 16px;
}

.room-price {
  flex: 0 0 auto;
  margin-right: 4px;
  color: #ff0b0b;
  font-size: 14px;
  font-weight: 700;
}

.room-sold {
  min-width: 0;
  overflow: hidden;
  color: #9aa2b1;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  padding: 80px 20px;
  color: #9aa2b1;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.save-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 22px;
  z-index: 20;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.save-btn {
  width: 202px;
  height: 54px;
  padding: 0;
  border: 0;
  border-radius: 27px;
  background: #ff1010;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 54px;
  text-align: center;
  box-shadow: 0 8px 20px rgba(255, 16, 16, .22);
  pointer-events: auto;
}

.save-btn:disabled {
  opacity: .72;
}
</style>
